// IP-based geolocation (no permission prompt) — uses free ipapi.co endpoint.
// Returns { city, region, country } or null. 6-hour sessionStorage cache.
import { useEffect, useState } from "react";

const CACHE_KEY = "geo_ipapi_v1";
const CACHE_TTL_MS = 6 * 60 * 60 * 1000;

export function useIpGeo() {
    const [geo, setGeo] = useState(null);

    useEffect(() => {
        let cancelled = false;
        try {
            const cached = sessionStorage.getItem(CACHE_KEY);
            if (cached) {
                const o = JSON.parse(cached);
                if (Date.now() - o.ts < CACHE_TTL_MS) {
                    setGeo(o.data);
                    return;
                }
            }
        } catch (_e) { /* ignore cache errors */ }

        // Best-effort fetch. Treat any failure as 'no geo'.
        fetch("https://ipapi.co/json/", { signal: AbortSignal.timeout?.(4000) })
            .then((r) => r.ok ? r.json() : null)
            .then((d) => {
                if (cancelled || !d) return;
                const data = {
                    city: d.city || null,
                    region: d.region || null,
                    country: d.country_name || null,
                    countryCode: d.country_code || null,
                };
                setGeo(data);
                try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), data })); } catch (_e) { /* ignore */ }
            })
            .catch(() => { /* silent — fallback is generic copy */ });

        return () => { cancelled = true; };
    }, []);

    return geo;
}
